import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickStats = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {stats?.map((stat, idx) => (
        <div key={idx} className="bg-card rounded-lg p-4 shadow-brand border-l-4" style={{ borderLeftColor: stat?.color }}>
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-medium text-muted-foreground">{stat?.label}</span>
            <Icon name={stat?.icon} size={20} color={stat?.color} />
          </div>
          <p className="text-2xl font-bold text-foreground">{stat?.value}</p>
          {stat?.subtext && (
            <p className="text-xs text-muted-foreground mt-1">{stat?.subtext}</p>
          )}
        </div>
      ))}
    </div>
  );
};

export default QuickStats;